import React from 'react';
import type { Dispatch } from 'react';

import { CheckboxSelect } from '@atlaskit/select';
import type { OptionType, ValueType } from '@atlaskit/select';

import { fg } from '@confluence/feature-gating';

import type { FilterKeys } from './filtersDefinitions';
import {
	FilterHeader,
	InputContainer,
	SelectContainer,
	FilterHeaderCompiled,
	InputContainerCompiled,
	SelectContainerCompiled,
} from './presentationalComponents';
interface CheckboxSelectOptions {
	label: string;
	value: string;
}

interface CheckboxFilterProps {
	filterKey: FilterKeys;
	options: CheckboxSelectOptions[];
	label: string;
	inputId: string;
	filterDispatch: Dispatch<any>;
	selectedValues: CheckboxSelectOptions[];
}

export const CheckboxSelectFilter = ({
	options,
	filterKey,
	label,
	inputId,
	filterDispatch,
	selectedValues,
}: CheckboxFilterProps) => {
	const onChange = (selected: ValueType<OptionType, true>) => {
		filterDispatch({
			type: filterKey,
			payload: selected.map((x: any) => x.value.toString()),
		});
	};

	if (fg('confluence_frontend_home_compiled_migration')) {
		return (
			<InputContainerCompiled data-testid={inputId}>
				<FilterHeaderCompiled htmlFor={inputId}>{label}</FilterHeaderCompiled>
				<SelectContainerCompiled>
					<CheckboxSelect
						inputId={inputId}
						options={options}
						value={selectedValues}
						isSearchable={false}
						onChange={onChange}
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
						className={inputId}
						classNamePrefix="react-select"
					/>
				</SelectContainerCompiled>
			</InputContainerCompiled>
		);
	}

	return (
		<InputContainer data-testid={inputId}>
			<FilterHeader htmlFor={inputId}>{label}</FilterHeader>
			<SelectContainer>
				<CheckboxSelect
					inputId={inputId}
					options={options}
					value={selectedValues}
					isSearchable={false}
					onChange={onChange}
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={inputId}
					classNamePrefix="react-select"
				/>
			</SelectContainer>
		</InputContainer>
	);
};
